import { useMediaQuery, useTheme } from '@mui/material';

/**
 * True below the given theme breakpoint (default `sm`, i.e. < 600px).
 *
 * The one sanctioned media-query hook: reach for it only when the rendered
 * tree has to change (full-screen dialogs, card-style table rows). Pure
 * sizing/layout changes belong in responsive `sx` values instead — see
 * src/utils/responsive.ts.
 */
export const useIsMobile = (bp: 'sm' | 'md' | 'lg' = 'sm') => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down(bp), { noSsr: true });
};
